import axios from '@/axios.js';

export default {
  data() {
    return {
      isSensitiveModalOpen: false,
      sensitiveModalDesc: '',
      pendingSensitiveAction: null,
      isModalOpen: false,
      selectedMediaSrc: '',
      selectedMediaType: 'image',
      imageExtensions: null,
      videoExtensions: null,
    };
  },
  methods: {
    handleSensitiveConfirmed() {
      if (typeof this.pendingSensitiveAction === 'function') {
        this.pendingSensitiveAction();
      }
      this.pendingSensitiveAction = null;
    },

    openMediaModal(srcPath) {
      if (!this.imageExtensions) {
        this.imageExtensions = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']);
        this.videoExtensions = new Set(['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv']);
      }
      const extension = srcPath.split('.').pop()?.toLowerCase();
      if (this.imageExtensions.has(extension)) {
        this.isModalOpen = true;
        this.selectedMediaSrc = srcPath;
        this.selectedMediaType = 'image';
      } else if (this.videoExtensions.has(extension)) {
        this.isModalOpen = true;
        this.selectedMediaSrc = srcPath;
        this.selectedMediaType = 'video';
      }
    },

    goToURL(value, platform) {
      if (!value || this.editor) return;

      let url = value;
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
      }

      // Open window immediately to preserve user gesture context and prevent popup blocker
      window.open(url, '_blank', 'noopener,noreferrer');

      // Send tracking in background
      this.sendSiteClickAsync(url, platform);
    },

    trackCardClick(value, platform) {
      if (!value || this.editor) return;

      let url = value;
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
      }

      this.sendSiteClickAsync(url, platform);
    },

    async sendSiteClickAsync(url, platform) {
      const siteId = this.harmony?.id || this.usedHarmony?.id;
      if (!siteId) return;

      let visitorId = localStorage.getItem('visitorId');
      if (!visitorId) {
        try {
          const FingerprintJS = await import(
            /* webpackChunkName: "fingerprint" */
            '@fingerprintjs/fingerprintjs'
          );
          const fp = await FingerprintJS.load();
          const result = await fp.get();
          visitorId = result.visitorId;
          localStorage.setItem('visitorId', visitorId);
        } catch (error) {
          console.error("Fingerprint error:", error);
        }
      }

      try {
        axios.post('/set-site-click', {
          site_id: siteId,
          url: url,
          platform: platform,
          fingerprint: visitorId
        }).catch(err => console.error('Error al registrar clic:', err));
      } catch (error) {
        console.error('Error al enviar clic:', error);
      }
    },

    async navigateToCard(card, src) {
      if (this.editor) return;

      const name = card?.name?.split('/')[0]?.toLowerCase() || '';
      const show = typeof src === 'object' ? src.show : true;
      const srcPath = typeof src === 'object' ? src.path : src;

      const url = card?.url2 || card?.url;
      if (url) {
        if (this.platformsAdult.includes(name)) {
          this.sensitiveModalDesc = this.$t('harmony.content+18');
          this.pendingSensitiveAction = () => this.goToURL(url, name);
          this.isSensitiveModalOpen = true;
          return;
        }

        return this.goToURL(url, name);
      }

      if (!srcPath) return;

      if (!show) {
        this.sensitiveModalDesc = this.$t('harmony.contentExplicitDesc');
        this.pendingSensitiveAction = () => this.openMediaModal(srcPath);
        this.isSensitiveModalOpen = true;
        return;
      }

      this.openMediaModal(srcPath);
    }
  }
}
